export default "__VITE_ASSET__BlwaofPR__"